export enum ResetTOTPStep {
    Default,
    EnterPhoneNumber,
    EnterOTP,
    NoPhoneNumber
}
